import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import Space, {spaceSizes} from "@/app/components/Space";
import {SubheadText} from "@/app/components/texts";
import {s} from "@/app/utils/s";
import {useTranslation} from "react-i18next";

interface StatusLineProps {
  commercialized?: boolean;
}

const StatusLine: React.FC<StatusLineProps> = ({
                                                 commercialized = false,
                                               }) => {
  const {t} = useTranslation();

  return (
    <div className={styles.status}>
      <div className={classNames(styles.dot, commercialized && styles.active)}></div>
      <Space w={spaceSizes.s4}/>
      <SubheadText text={commercialized ? t(s.available) : t(s.notAvailable)}/>
    </div>
  );
};

export default StatusLine;